"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es7.array.includes");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _router = _interopRequireDefault(require("./router"));

var _store = _interopRequireDefault(require("./store"));

var _elementUi = require("element-ui");

var _nprogress = _interopRequireDefault(require("nprogress"));

require("nprogress/nprogress.css");

var _auth = require("@/utils/auth");

var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));

var _lang = _interopRequireDefault(require("@/lang"));

// progress bar
// progress bar customCSS
// get token from cookie
// import localStorage from "js-cookie";
_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration


var whiteList = ["/adminLogin", "/agentLogin", "/merchantLogin", "/auth-redirect", "/paySuccess", "/payFailure"]; // no redirect whitelist

var warningIfNotVerified = function warningIfNotVerified(next) {
  if (_store.default.getters.isForced) {
    _elementUi.MessageBox.confirm(_lang.default.t("googleCodeRemarkMessage.googleCodeRemarkMessage"), _lang.default.t("googleCodeRemarkMessage.googleCodeRemarkTitle"), {
      confirmButtonText: _lang.default.t("googleCodeRemarkMessage.confirmButtonText"),
      cancelButtonText: _lang.default.t("googleCodeRemarkMessage.cancelButtonText"),
      type: 'warning'
    }).then(function () {
      // route to bind google code page
      next('/sms-account-management/bind-google-code');
    }).catch(function () {
      return null;
    });
  }
};

_router.default.beforeEach(
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, mode, hasRoles;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            _nprogress.default.start(); // set page title


            document.title = (0, _getPageTitle.default)(to.meta.title); // determine whether the user has logged in

            _context.next = 4;
            return (0, _auth.getToken)();

          case 4:
            hasToken = _context.sent;
            mode = _store.default.getters.mode || to.meta.mode || "merchant";

            if (!hasToken) {
              _context.next = 30;
              break;
            }

            if (!(whiteList.indexOf(to.path) !== -1)) {
              _context.next = 12;
              break;
            }

            // if is logged in, redirect to the home page
            next();

            _nprogress.default.done();

            _context.next = 28;
            break;

          case 12:
            // determine whether the user has obtained his permission roles through getInfo
            hasRoles = _store.default.getters.roles && _store.default.getters.roles.length > 0;

            if (hasRoles) {
              _context.next = 25;
              break;
            }

            _context.prev = 14;
            _context.next = 17;
            return _store.default.dispatch("user/getInfo");

          case 17:
            _context.next = 19;
            return _store.default.dispatch("permission/generateRoutes");

          case 19:
            next();
            _context.next = 25;
            break;

          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](14);
            console.log(_context.t0);

          case 25:
            if (whiteList.includes(from.path) && to.path !== from.path) {
              warningIfNotVerified(next);
            }

            next();

            _nprogress.default.done();

          case 28:
            _context.next = 32;
            break;

          case 30:
            /* has no token*/
            if (whiteList.indexOf(to.path) !== -1) {
              next();
            } else {
              next("/".concat(mode, "Login"));
            }

            _nprogress.default.done();

          case 32:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[14, 22]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});